import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import Header from "../components/Header";
import Footer from "../components/Footer";

const NotFound = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Redirect to Home after 1.5 seconds
        const timer = setTimeout(() => navigate("/home"), 1500);
        return () => clearTimeout(timer); // Cleanup timer
    }, [navigate]);

    return (
        <div className="min-h-screen flex flex-col bg-black text-[#f5c6d6]">
            {/* Header */}
            <Header />

            {/* Main Content */}
            <div className="flex-grow flex items-center justify-center text-center px-4">
                <motion.div
                    initial={{ opacity: 0, y: -50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    className="max-w-lg p-6"
                >
                    {/* Title */}
                    <h1
                        className="text-5xl md:text-6xl font-extrabold mb-4 tracking-wide"
                        style={{ fontFamily: "'Poppins', sans-serif" }}
                    >
                        Oops!
                    </h1>

                    {/* Message */}
                    <p className="text-lg md:text-xl mb-6">The page you're looking for doesn't exist.</p>
                    <p className="text-sm md:text-base text-gray-300 mb-4">Redirecting to the Home page...</p>

                    {/* Loader Animation */}
                    <div className="flex justify-center space-x-2">
                        {[0, 0.2, 0.4].map((delay, index) => (
                            <motion.div
                                key={index}
                                className="w-4 h-4 md:w-5 md:h-5 bg-[#f5c6d6] rounded-full"
                                animate={{ y: [0, -10, 0] }}
                                transition={{
                                    repeat: Infinity,
                                    duration: 0.6,
                                    ease: "easeInOut",
                                    delay,
                                }}
                            />
                        ))}
                    </div>
                </motion.div>
            </div>

            {/* Footer */}
            <Footer />
        </div>
    );
};

export default NotFound;
